module.exports = __webpack_public_path__ + "static/media/AvenirBlack.d10ab385.ttf";